import { api } from "./api";
import {
  CREATE_ASSIGNMENT,
  GET_UPCOMING_ASSIGNMENTS,
  GET_SUBMITTED_ASSIGNMENTS,
} from "../apiEndPoints";

export const assignmentApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    createAssignment: builder.mutation({
      query: (payload) => ({
        url: CREATE_ASSIGNMENT,
        method: "POST",
        body: payload,
      }),
    }),
    getUpcomingAssignments: builder.query({
      query: ({
        student_id,
        coaching_id,
        coaching_name,
        batch_name,
        subject,
      }) => {
        let URL = `${GET_UPCOMING_ASSIGNMENTS}?student_id=${student_id}`;
        if (coaching_id) {
          URL += `&coaching_id=${coaching_id}`;
        }
        if (coaching_name) {
          URL += `&coaching_name=${coaching_name}`;
        }
        if (batch_name) {
          URL += `&batch_name=${batch_name}`;
        }
        if (subject) {
          URL += `&subject=${subject}`;
        }
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
    getSubmittedAssignments: builder.query({
      query: ({
        student_id,
        coaching_id,
        coaching_name,
        batch_name,
        subject,
      }) => {
        console.log("student_id, coaching_name", student_id, coaching_name);
        let URL = `${GET_SUBMITTED_ASSIGNMENTS}?student_id=${student_id}`;
        if (coaching_id) {
          URL += `&coaching_id=${coaching_id}`;
        }
        if (coaching_name) {
          URL += `&coaching_name=${coaching_name}`;
        }
        if (batch_name) {
          URL += `&batch_name=${batch_name}`;
        }
        if (subject) {
          URL += `&subject=${subject}`;
        }
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateAssignmentMutation,
  useGetUpcomingAssignmentsQuery,
  useGetSubmittedAssignmentsQuery,
} = assignmentApiSlice;
